import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ApiFetcher } from '@ts-rest/core';
import { initQueryClient } from '@ts-rest/react-query';
import { apiContract } from '@archie/api-shared';
import { QueryApiContext } from './QueryContext';
import { fetchApiWithSignedBody } from '../utils/signedFetch';

const defaultQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
});

export const QueryProvider = ({
  children,
  baseUrl,
  overrideApi,
  queryClient = defaultQueryClient
}: {
  children: React.ReactNode;
  baseUrl: string;
  overrideApi?: ApiFetcher;
  queryClient?: QueryClient;
}) => {
  const tsRestClient = initQueryClient(apiContract, {
    baseUrl: baseUrl,
    api: overrideApi ?? fetchApiWithSignedBody,
    credentials: 'include'
  });

  return (
    <QueryApiContext.Provider value={tsRestClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </QueryApiContext.Provider>
  );
};
